import { ActionTree } from "vuex";
import { State } from "./state";
import { BooksAllowedEnum } from "@/enums/BooksAllowedEnum";

import axios from "@/utils/axios";

import {
  IS_LOADING,
  SET_SUCCESS,
  SET_ERROR,
  SET_PAGE_LOADING,
  SET_BASE_BOOK,
  SET_ADDITIONAL_BOOK_A,
  SET_ADDITIONAL_BOOK_B,
  SET_BASE_PAGE,
  SET_BOOK_A_PAGE,
  SET_BOOK_B_PAGE,
} from "@/store/WikiDriveBuzz/types";

const URL = "/wiki-drive-buzz";

export const findBook = async (store: any, bookId: number): Promise<any> => {
  store.commit(IS_LOADING, true);

  return await axios
    .get(URL + `/books/${bookId}`)
    .then(({ data }) => {
      if (bookId === BooksAllowedEnum.BASE_KNOWLEDGE) {
        store.commit(SET_BASE_BOOK, data);
      } else if (bookId === BooksAllowedEnum.ADDITIONAL_KNOWLEDGE_CATEGORY_A) {
        store.commit(SET_ADDITIONAL_BOOK_A, data);
      } else if (bookId === BooksAllowedEnum.ADDITIONAL_KNOWLEDGE_CATEGORY_B) {
        store.commit(SET_ADDITIONAL_BOOK_B, data);
      }
      store.commit(SET_SUCCESS, true);
    })
    .catch(({ error }) => {
      store.commit(SET_SUCCESS, false);
      store.commit(SET_ERROR, error);
    })
    .finally(() => store.commit(IS_LOADING, false));
};

export const findHtmlPage = async (store: any, payload: any): Promise<any> => {
  store.commit(SET_PAGE_LOADING, true);

  return await axios
    .get(URL + `/pages/${payload.pageId}/html`)
    .then(({ data }) => {
      if (payload.bookId === BooksAllowedEnum.BASE_KNOWLEDGE) {
        store.commit(SET_BASE_PAGE, data);
      } else if (payload.bookId === BooksAllowedEnum.ADDITIONAL_KNOWLEDGE_CATEGORY_A) {
        store.commit(SET_BOOK_A_PAGE, data);
      } else if (payload.bookId === BooksAllowedEnum.ADDITIONAL_KNOWLEDGE_CATEGORY_B) {
        store.commit(SET_BOOK_B_PAGE, data);
      }
      store.commit(SET_SUCCESS, true);
    })
    .catch(({ error }) => {
      store.commit(SET_SUCCESS, false);
      store.commit(SET_ERROR, error);
    })
    .finally(() => store.commit(SET_PAGE_LOADING, false));
};

export default <ActionTree<State, any>>{
  findBook,
  findHtmlPage,
};
